<section class="ch2">
    <section class="header-zone1">
        <ng-content select="[header-zone1]"></ng-content>
    </section>
    <section class="header-zone2">
        <ng-content select="[header-zone2]"></ng-content>
    </section>
    <section class="visu-zone">
        <ng-content select="[visu-zone]"></ng-content>
    </section>
</section>
